module.exports = {"520623001":"汤山街道","520623002":"泉都街道","520623003":"中坝街道","520623101":"本庄镇","520623102":"白沙镇","520623103":"龙塘镇","520623104":"花桥镇","520623105":"五德镇","520623107":"河坝镇","520623201":"国荣乡","520623202":"聚凤仡佬族侗族乡","520623203":"龙井仡佬族侗族乡","520623204":"大沙坝仡佬族侗族乡","520623205":"枫香仡佬族侗族乡","520623206":"青阳苗族仡佬族侗族乡","520623207":"石固仡佬族侗族乡","520623208":"坪地场仡佬族侗族乡","520623209":"甘溪仡佬族侗族乡","520623210":"坪山仡佬族侗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520623.json
// module id = 2495
// module chunks = 0